import { axios } from '@/utils/request'

export function queryAllPayrollInfo (parameter = {}) {
  return axios({
    url: '/payroll/queryAllPayrollInfo',
    method: 'post',
    data: parameter
  })
}

export function queryPayrollDetail (parameter = {}) {
  return axios({
    url: '/payroll/queryPayrollDetailInfo',
    method: 'post',
    data: parameter
  })
}

export function savePayrollDetail (parameter = {}) {
  return axios({
    url: '/payroll/updatePayrollDetailInfo',
    method: 'post',
    data: parameter
  })
}

export function rejectAudit (parameter = {}) {
  return axios({
    url: '/payroll/rejectAudit',
    method: 'post',
    data: parameter
  })
}

export function passPayroll (parameter = {}) {
  return axios({
    url: '/payroll/passPayroll',
    method: 'post',
    data: parameter
  })
}

export function submitAudit (parameter = {}) {
  return axios({
    url: '/payroll/submitAudit',
    method: 'post',
    data: parameter
  })
}

export function addPayrollDetail (parameter = {}) {
  return axios({
    url: '/payroll/insertDetail',
    method: 'post',
    data: parameter
  })
}